import React, {Component} from 'react';

const FeatureItem = ({title, type}) =>
	<div className={`gcAd-${type}-features-thumb`}>
		<span className={`gcAd-${type}-features-thumb-title`}>
			{title}
		</span>
	</div>

class FeaturesList extends Component {
	render() {

		const {FeaturesList, title, type } = this.props;
		return (
			<section id="sgFeatures" className={`gcAd-section game-features is-${type}`} data-section="5">
				<div id="sgFeaturesTitle" className={`gcAd-${type}-features-title`}>
					{title}
				</div>
				<div id="sgFeaturesThumbs" className={`gcAd-${type}-features-thumbs`}>
					{FeaturesList.map(feature =>
						                  <FeatureItem
							                  key={Object.keys(FeaturesList)[FeaturesList.indexOf(feature)]}
							                  title={feature.Title}
											  type={type}
						                  />
					)
					}
				</div>
			</section>
		)
	}
}

export default FeaturesList;


// WEBPACK FOOTER //
// ./src/Components/Advert-Features.js